module.exports = __webpack_public_path__ + "img/id.8f5da81e.svg";